import { Button } from '@heroui/react'

interface InlineSaveButtonProps {
  onClick: () => void
  isLoading: boolean
  ariaLabel: string
  title: string
}

export const InlineSaveButton = ({
  onClick,
  isLoading,
  ariaLabel,
  title
}: InlineSaveButtonProps) => (
  <Button
    isIconOnly
    size="sm"
    isLoading={isLoading}
    onPress={onClick}
    aria-label={ariaLabel}
    title={title}
    className="ml-1 h-8 rounded-[3px] border border-[var(--ds-border)] !bg-green-700 hover:!bg-green-600 dark:!bg-green-600 dark:hover:!bg-green-500 cursor-pointer focus:outline-none focus:border-[var(--ds-border-focused)] transition"
    style={{ alignSelf: 'center' }}
  >
    <svg
      width="20"
      height="20"
      fill="none"
      stroke="white"
      strokeWidth="2"
      viewBox="0 0 20 20"
      aria-label="Save"
      role="img"
    >
      <path d="M5 10l4 4 6-8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </Button>
)
